export const iconFontAwesomeSecurityBurst = (
	<i className="fa-solid fa-burst"></i>
);
